export default __webpack_public_path__ + "static/media/Pizza.f9b6d347.jpeg";